<script>
import Section from '../../components/PageSection';
import Modal from '../../components/Modale';
// import DeleteUser from '../../components/equipe/DeleteConfirm';
import ModalYesNo from '../../components/ModalYesNo';
import ValFlagger from '../../components/params/ValFlagger'


export default {
  name: 'PageUser',
  components:{
      Section,
      Modal,
    //   DeleteUser,
      ModalYesNo,
      ValFlagger,
  },

  data(){
    return{
      fullyLoaded: false,
      user: null,
      isLastAdmin: true, //La page en cours est celle du dernier administrateur actif
      mdp: {
          saisie:"",
          confirmation:""
        },
      modalErreurs: "",
      isModalVisible_mdp: false,
      isModalVisible_deleteUser: false,
      roles: [],
      coeffs: [],
      selectedCoeff: "",

    }
  },
  async mounted(){
    const promiseUser = this.$axios.get('users/'+ this.$route.params._id)
    .then(response => (this.user = response.data))
    
    const promiseLastAdmin = this.$axios.get('users/isLastAdmin/' + this.$store.state.auth.currentAgence._id + '/' + this.$route.params._id)
    .then(response => this.isLastAdmin = response.data.isLastAdmin)
    
    const promiseRoles = this.$axios.get('roles/getByAgence/' + this.$store.state.auth.currentAgence._id)
    .then(response => this.roles = response.data)

    const coeffLabels = this.$axios.get('coeffLabels/getActive/' + this.$store.state.auth.currentAgence._id)
      .then(response => this.coeffs = response.data)
      .catch(err => this.alert(err))

    await Promise.all([promiseUser, promiseRoles, promiseLastAdmin, coeffLabels])
    
    //Par défaut je regarde s'il y a un coefficient favori. Sinon je prends le premier de la liste.
    this.selectedCoeff = this.user.coefficientFavori || this.coeffs[0]._id
    this.fullyLoaded = true;

    //S'il n'y a pas de rôle assigné, j'assigne le rôle par défaut (celui qui arrive en premier car c'est trié comme tel dans la réponse du serveur)
    if (this.user.roleId == undefined){
        this.$axios.put('users/'+ this.user._id, {roleId: this.roles[0]._id})
        .then(
            this.$set(this.user, 'roleId', this.roles[0]._id)    
        )
    }
  },

  methods:{
    update(e){
        let erreurs = false
        switch(e.target.name){
            // case 'name':
            //     // TODO : Vérifier et modifier la casse si nécessaire
            //     break;

            // case 'surname':
            //     // TODO : Vérifier et modifier la casse si nécessaire
            //     break;

            case 'email':
                //adresse mail valide   
                if ( 
                    !this.user.email.includes("@") || 
                    !this.user.email.includes(".") ||
                    this.user.email.indexOf(".", this.user.email.indexOf("@")) == -1
                    ) {
                    e.target.classList.add("fieldError")
                    erreurs = true
                } else {
                    e.target.classList.remove("fieldError")
                    erreurs = false
                }
                break;

            case 'active':
                //conversion de la propriété active du formulaire (en string) à un vrai boolean
                this.user.active = (this.user.active === "true" || this.user.active === true)
                break;

            case 'role':
                this.user.role = e.target.value
                break;

            case 'coeff':
                this.user.coefficientFavori = e.target.value
                // this.$store.state.auth.currentUser.coefficientFavori = e.target.value
                this.$store.dispatch('auth/set_coeffFavori', e.target.value);
                break;
        }
        //Si pas d'erreurs, je mets à jour l'user
        if (!erreurs) {
            this.$axios.put('users/'+ this.user._id, this.user)
                .then(response => (console.log(response.data)))
                .catch(err => (console.log(err)))
        } else {
            console.log("Merci de corriger les erreurs.")
        }

        //ce qui marchait avant
        //  if (this.erreurs.length === 0) {
        //     this.$axios.put('users/'+ this.user._id, this.user)
        //         .then(response => (console.log(response.data)))
        //         .catch(err => (console.log(err)))
        // } else {
        //     console.log("Merci de corriger les erreurs.")
        //     console.log(this.erreurs)
        // }
    },

    // showModal_deleteUser(){
    //   this.isModalVisible_deleteUser = true;
    // },
    showModal_mdp(){
      this.isModalVisible_mdp = true;
    },
    closeModal(){
      this.isModalVisible_mdp = false;
      this.isModalVisible_deleteUser = false;
    },

    goBack(){
        this.$router.push('/equipe/utilisateurs');
    },

    checkMdp(){
        if(this.mdp.saisie === this.mdp.confirmation){
            this.modalErreurs = "";
            return true;
        } else if(this.mdp.saisie != "" && this.mdp.confirmation != ""){
            this.modalErreurs = "Les deux mots de passe ne correspondent pas...";
        }
    },
    updateMdp(){
        if(this.checkMdp()){
            //mettre à jour data{user}
            this.user.password = this.mdp.saisie;
            //envoyer data{user} sur le server
            this.$axios.put('users/mdp/'+ this.user._id, this.user)
                .then(response => (console.log(response)))
                .catch(e => (console.log(e)))
            this.closeModal();
        }
    },
  },
}
</script>


<template>
                <!-- https://www.digitalocean.com/community/tutorials/how-to-handle-file-uploads-in-vue-2 -->
                <!-- https://blog.bitsrc.io/uploading-files-and-images-with-vue-and-express-2018ca0eecd0 -->
                <!-- https://stackoverflow.com/questions/56574322/sending-an-image-with-axios-to-node-js-and-then-using-it-further -->
    <div v-if="user != null" class="user-main">
        <div class="userInfos">
            <div class="userInfos__avatar">
                <img src="../../assets/userIcon.png">
            </div>
            <div class="userInfos__content">
                <div class="userInfos__content__name"> {{user.name + ' ' + user.surname}} </div>
                <div class="userInfos__content__mail"> {{user.email}} </div>
                <div class="userInfos__content__footer">
                    <!-- <span class="material-icons">delete_forever</span> -->
                </div>
            </div>
        </div>
        
        <Section text="Informations générales" underlined="true" class="userGeneral">
            <template v-slot:body>
                <span class="userGeneral__line"><label class="userGeneral__label">Prénom : </label><input class="userGeneral__input" name="name"    @change="update($event)" type="text" v-model="user.name" ></span>
                <span class="userGeneral__line"><label class="userGeneral__label">Nom :    </label><input class="userGeneral__input" name="surname" @change="update($event)" type="text" v-model="user.surname" ></span>
                <span class="userGeneral__line"><label class="userGeneral__label">E-mail : </label><input class="userGeneral__input" name="email"   @change="update($event)" type=email v-model="user.email" ></span>
                <input type=button class="userGeneral__bouton" value="Changer de mot de passe" @click="showModal_mdp">
                    <Modal v-show="isModalVisible_mdp" @close="closeModal">
                        <template v-slot:header>
                            <span>Changer de mot de passe</span>
                        </template>
                        <template v-slot:body>
                            <div id="newMdpWrapper" v-on:change="checkMdp">
                                <input type="password" v-model="mdp.saisie" placeholder="Veuillez entrez le nouveau mot de passe"/><br>
                                <input type="password" v-model="mdp.confirmation" placeholder="Veuillez confirmer le mot de passe"/><br>
                                <p class="erreur"> {{modalErreurs}} </p>
                            </div>
                        </template>
                        <template v-slot:footer>
                            <ModalYesNo @no="closeModal" @yes="updateMdp"></ModalYesNo>
                        </template>
                    </Modal>
            </template>
        </Section>
        
        <Section text="Salaire brut" underlined="true" class="userSalaire">
            <template v-slot:body>
                <ValFlagger class="userSalaire__valFalgger" unit="€" array="salaire" :api="'users/' + user._id" />
            </template>
        </Section>

        <Section text="Compte utilisateur" underlined="true" class="userAccount">
            <template v-slot:body>
                <div class="userAccount__oneBlock info" v-if="isLastAdmin">
                    Ce compte est le dernier compte administrateur actif. Par conséquent, vous ne pouvez pas le désactiver.
                </div>
                <div class="userAccount__oneBlock">
                    <div class="userAccount__oneBlock__flexline">
                        <div>Statut utilisateur :</div>
                        <div>
                            <input name="active" type=radio id="active"   value="true"  v-model="user.active" @change="update($event)" :disabled="isLastAdmin"><label for="active"   class="userAccount__label">Actif</label>
                            <input name="active" type=radio id="inactive" value="false" v-model="user.active" @change="update($event)" :disabled="isLastAdmin"><label for="inactive" class="userAccount__label">Inactif</label><br>
                        </div>
                    </div>
                    <div>Un utilisateur inactif ne peut plus accéder à l'application.</div>
                </div>
                <div class="userAccount__oneBlock">
                    <div class="userAccount__oneBlock__flexline">
                        <div>Rôle :</div>
                        <select name="role" id="role" v-model="user.roleId" @change="update($event)" :disabled="isLastAdmin">
                            <option v-for="role in roles" :key="role._id" :value="role._id"> {{role.name}} </option>
                        </select>
                    </div>
                </div>
            </template>
        </Section>

        <Section text="Temps de travail" underlined="true" class="userTrempsTravail">
            <template v-slot:body>
                <div class="userAccount__oneBlock__flexline">
                    <div>Contrat :</div>
                    <div>
                        <input name="tempsPartiel" id="false" type=radio value="false" v-model="user.tempsPartiel" @change="update($event)" ><label for="false" class="userAccount__label">Temps plein</label>
                        <input name="tempsPartiel" id="true"  type=radio value="true"  v-model="user.tempsPartiel" @change="update($event)" ><label for="true"  class="userAccount__label">Temps partiel</label><br>
                        <!-- Plus tard : temps partiel sera une sélection des demi journées travaillées par le collaborateur afin que le calcul
                        du nombre de jours à remplir sur le feuille des temps soit juste pour eux aussi. Cela permettra également de calculer
                        le salaire brut journalier réel, car en l'état je divise le salaire du temps partiel sur le nombre de jours d'un temps
                        plein, donc le coût de revient est faux pour ces salariés. -->
                    </div>
                </div>
            </template>
        </Section>

        <Section text="Préférences" underlined="true" class="userAccount" v-if="can('lecture','tempsAdmin')">
            <template v-slot:body>
                <div class="userAccount__oneBlock">
                    <div class="userAccount__oneBlock__flexline">
                        <div>Coefficient par défaut :</div>
                        <div class="preferences-list">
                            <div v-for="item in coeffs" :key="item._id">
                                <input name="coeff" type="radio" :id="item._id" v-model="selectedCoeff" :value="item._id" @change="update($event)">
                                <label class="coeffs__label" :for="item._id"> {{item.name}} </label>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </Section>
        
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/main.scss';

.user-main{
    width: 700px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 50px;
}

.userInfos{
    @include myBlock;
    grid-column: 1 / span 2;
    display: flex;
    overflow:hidden;

    &__avatar{
        & img{
            height: 180px;
        }
    }

    &__content{
        padding: 20px;
        display: flex;
        flex-direction: column;
        width: 100%;

        &__name{
            @include myFont;
            color: $main;
            font-size: 22px;
            font-weight: 600;
        }

        &__mail{
            @include myFont;
            color: $black-bold;
            font-size: 16px;
            margin: 5px 0 0 0;
        }

        &__footer{
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
        }
    }
}

.userGeneral{
    &__line{
        display: flex;
        justify-content: space-between;
        margin: 0 0 5px 0;
    }

    &__label{
        @include myFont;
        font-size: 13px;
        color: $black-bolder;
    }

    &__input{
        @include myFont;
        font-size: 13px;
        color: $black-bolder;
        border-width: 0 0 1px 0;
        border-color: $black-light;
        background-color: $black-lighter;
        width: 240px;
    }

    &__bouton{
        @include myButton;
        margin-top: 15px;
        width: 100%;
    }
}

.userAccount{
    @include myFont;
    font-size: 13px;
    color: $black-bolder;

    &__label{
        @include myFont;
        font-size: 13px;
        color: $black-bolder;
        margin: 0 15px 0 0;
        position: relative;
        top: -1px;
    }

    &__oneBlock{
        margin: 0 0 15px 0;

        &__flexline{
            display: flex;
            justify-content: space-between;
            margin: 0 0 5px 0;
            @include myFont;
            font-size: 13px;
            color: $black-bolder;
        }
    }
}

.preferences{
    &-list{
        flex: 1;
        margin: 0 0 0 15px;
    }
}

.fieldError{
    @include myFieldError;
}

.info{
    @include myFont;
    font-size: 13px;
    color: $black;
}
</style>